// extracted by mini-css-extract-plugin
export default {"skeleton":"OPKBZG","skeletonButton":"Z3fi8m","skeletonGroup":"pUq3di","infoIcon":"qnz_53"};